import { AriaColorFieldProps, useColorField } from "@react-aria/color";
import { useColorFieldState } from "@react-stately/color";
import * as React from "react";
import { cx } from "../../utils/dom";
import { Field, FieldComponentProps } from "../form/field";

type ColorFieldProps = AriaColorFieldProps & FieldComponentProps<"input">;

export function ColorField({
  label,
  description,
  className,
  classNames,
  style,
  styles,
  ...props
}: ColorFieldProps) {
  const state = useColorFieldState(props);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { inputProps, labelProps, descriptionProps, errorMessageProps } =
    useColorField(
      { ...props, "aria-label": props["aria-label"] ?? "color-field" },
      state,
      inputRef
    );

  return (
    <Field
      description={description}
      label={label}
      style={style}
      classNames={classNames}
      className={className}
      styles={styles}
      labelProps={{ ...labelProps }}
      descriptionProps={{ ...descriptionProps }}
      errorMessageProps={{ ...errorMessageProps }}
      {...props}
    >
      <input
        style={styles?.input}
        className={cx(classNames?.input, "p-text-input-el")}
        type="text"
        ref={inputRef}
        {...inputProps}
      />
    </Field>
  );
}
